function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/// <reference types="@types/googlemaps" />
import React, { createContext, useState, useContext, useRef, useEffect } from 'react';
import { useScript } from '@dfds-ui/hooks';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var GooglePlacesAPIContext = /*#__PURE__*/createContext({
  available: false
});
export var GooglePlacesAPIProvider = function GooglePlacesAPIProvider(_ref) {
  var _window, _window$google;
  var children = _ref.children,
    apiKey = _ref.apiKey,
    language = _ref.language,
    _ref$libraries = _ref.libraries,
    libraries = _ref$libraries === void 0 ? 'places' : _ref$libraries;
  // On SSR window does not exist.
  var hasWindow = typeof window !== 'undefined';

  // We want to prevent the google maps api to be loaded more than once
  var isGoogleMapsDefined = hasWindow && Boolean((_window = window) === null || _window === void 0 ? void 0 : (_window$google = _window.google) === null || _window$google === void 0 ? void 0 : _window$google.maps);
  var languageParam = language ? "&language=".concat(language) : '';
  // NOTE: Google Maps API requires a callback when ran asynchronously. See https://developers.google.com/maps/documentation/javascript/url-params#required_parameters
  // Dummy callback to satisfy Google Maps API.
  var dummyCallback = function dummyCallback() {
    return;
  };
  // @ts-expect-error dummyCallback does not exist on window. A callback is required by Google Maps API.
  if (hasWindow) window.dummyCallback = dummyCallback;
  var callback = hasWindow ? "&callback=dummyCallback" : '';
  var scriptUrl = "https://maps.googleapis.com/maps/api/js?key=".concat(apiKey, "&libraries=").concat(libraries).concat(languageParam).concat(callback);
  var _useScript = useScript(scriptUrl, isGoogleMapsDefined),
    _useScript2 = _slicedToArray(_useScript, 2),
    loaded = _useScript2[0],
    error = _useScript2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    available = _useState2[0],
    setAvailable = _useState2[1];
  useEffect(function () {
    setAvailable(loaded && !error);
    if (error) {
      throw new Error('Google Places API script failed to load');
    }
  }, [loaded, error]);
  return ___EmotionJSX(GooglePlacesAPIContext.Provider, {
    value: {
      available: available
    }
  }, children);
};
export var useGooglePlacesAPI = function useGooglePlacesAPI() {
  var context = useContext(GooglePlacesAPIContext);
  if (context === undefined) {
    throw new Error('useGooglePlaces must be used inside of GooglePlacesAPIProvider');
  }
  return context;
};
export var useAddressPredictions = function useAddressPredictions(input, _ref2) {
  var types = _ref2.types,
    location = _ref2.location,
    radius = _ref2.radius,
    components = _ref2.components;
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    predictions = _useState4[0],
    setPredictions = _useState4[1];
  var _useGooglePlacesAPI = useGooglePlacesAPI(),
    available = _useGooglePlacesAPI.available;
  var autocomplete = useRef();
  if (!autocomplete.current && available && typeof window !== 'undefined') {
    autocomplete.current = new google.maps.places.AutocompleteService();
  }
  function getPlacePredictions(input) {
    return new Promise(function (resolve) {
      autocomplete.current.getPlacePredictions({
        input: input,
        types: types,
        radius: radius,
        location: location !== undefined ? {
          lat: function lat() {
            return location !== undefined ? location.lat : undefined;
          },
          lng: function lng() {
            return location !== undefined ? location.lng : undefined;
          }
        } : undefined,
        componentRestrictions: {
          country: components.countries
        }
      }, function (predictions) {
        var _predictions;
        predictions = (_predictions = predictions) !== null && _predictions !== void 0 ? _predictions : [];
        setPredictions(predictions);
        resolve(predictions);
      });
    });
  }
  useEffect(function () {
    if (input !== '') {
      void getPlacePredictions(input);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input]);
  return {
    available: available,
    predictions: predictions,
    getPlacePredictions: getPlacePredictions
  };
};